import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 bg-beige relative" data-id="element-80">
      <div className="container mx-auto px-6 max-w-3xl text-center" data-id="element-81">
        <FadeIn data-id="element-82">
          <div className="w-16 h-16 mx-auto bg-sage/20 rounded-full flex items-center justify-center mb-6" data-id="element-83">
            <ShieldCheck className="w-8 h-8 text-sage-dark" data-id="element-84" />
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-charcoal mb-4" data-id="element-85">
            Garantía de 7 Días
          </h2>
          <p className="font-body text-charcoal/70 leading-relaxed" data-id="element-86">
            Pruébalo por 7 días. Si no sientes claridad… si no entiendes algo
            que antes no entendías… te devolvemos el 100% de tu dinero. Sin
            preguntas.
          </p>
        </FadeIn>
      </div>
    </section>;
}